export enum PreviewType {
  First20Sec = 'first-20-sec',
  Trailer = 'trailer',
  Autogenerated = 'autogenerated',
  None = 'none',
}
